var common = require("../utiles/common");
var app = require("./language/app");

module.exports = {
  _i18n: function (str) {
    var isZh = common.isZh();
    return app.getLanguageValue(str, isZh);
  },
};



//////////////////
// WEBPACK FOOTER
// ./src/_i18n/index.js
// module id = 12
// module chunks = 0